import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { I18n } from "@lingui/react";
import { Trans } from "@lingui/macro";
import {
  Checkbox,
  IconButton,
  SettingsListOutline,
  palette,
} from "@conserveit/blocks";
import {
  updateActiveColumns,
  toggleIncludeOpenIssues,
} from "../../../redux/modules/_BETA/actionsUI";
import Menu from "../../../components/Menu";

import { ActiveColumnsProps } from "../../../components/Issues/issue.propTypes";
import { actionColumns } from "../../../utils/columns";
import { $Select } from "./ActionsMenus.styles";

@connect(
  (state) => {
    const { user } = state.auth;
    const canViewOpen = user?.access?.includes("admin_statuses") || false;
    return {
      activeColumns: state.betaActionsUI.activeColumns,
      includeOpenStatus: state.betaActionsUI.includeOpenStatus,
      canViewOpen,
    };
  },
  (dispatch) => ({
    onColumnToggle: (column) => () => dispatch(updateActiveColumns(column)),
    toggleShowOpen: () => {
      dispatch(toggleIncludeOpenIssues());
    },
  })
)
class ColumnSelect extends PureComponent {
  static propTypes = {
    activeColumns: ActiveColumnsProps.isRequired,
    onColumnToggle: PropTypes.func.isRequired,
  };

  render() {
    const { activeColumns, includeOpenStatus, toggleShowOpen, canViewOpen } =
      this.props;

    return (
      <I18n>
        {({ i18n }) => (
          <Menu>
            {({ isOpen, menuRef, toggle }) => (
              <$Select ref={menuRef}>
                <IconButton
                  icon={<SettingsListOutline fillColor={palette.neutral9} />}
                  onClick={toggle}
                />
                <$Select.list isOpen={isOpen}>
                  <$Select.title>
                    <Trans id="actions.show_columns">SHOW COLUMNS</Trans>
                  </$Select.title>
                  {Object.entries(actionColumns).map(([key, column]) => (
                    <$Select.option key={key} disabled={column.disabled}>
                      <Checkbox
                        disabled={column.disabled}
                        checked={activeColumns[key]}
                        label={column.label(i18n)}
                        onChange={this.props.onColumnToggle(key)}
                      />
                    </$Select.option>
                  ))}
                  {canViewOpen && (
                    <Fragment>
                      <$Select.title>
                        <Trans id="actions.filters">Filters</Trans>
                      </$Select.title>
                      <$Select.option onClick={toggleShowOpen}>
                        <Checkbox
                          checked={includeOpenStatus}
                          label={
                            <Trans id="actions.include_open_status">
                              Include 'Open' status
                            </Trans>
                          }
                        />
                      </$Select.option>
                    </Fragment>
                  )}
                </$Select.list>
              </$Select>
            )}
          </Menu>
        )}
      </I18n>
    );
  }
}

export default ColumnSelect;
